import { API_URL } from '../config/api';

export const uploadAsset = async (file: File, token: string) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await fetch(`${API_URL}/assets/upload`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}` // تمرير JWT للحماية
    },
    body: formData
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || 'فشل في رفع الملف');
  }

  return response.json();
};